import React from 'react';
import './BusinessImpact.css';

const renderImpactIcon = (type) => {
  switch (type) {
    case "finance":
    case "revenue":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      );
    case "growth":
    case "intake":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case "reputation":
    case "brand":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      );
    case "manpower":
    case "staffing":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case "audit":
    case "protection":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      );
    case "time":
    case "delay":
    default:
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      );
  }
};

const BusinessImpact = ({
  badge = "Business Impact",
  heading,
  subtitle,
  impacts = []
}) => {
  if (!heading && (!impacts || impacts.length === 0)) return null;

  return (
    <section className="business-impact-section">
      {/* Ambient Lighting Circle */}
      <div className="business-impact-ambient-circle"></div>

      <div className="business-impact-container">
        
        {/* ================= ASYMMETRICAL SPLIT LAYOUT ================= */}
        <div className="business-impact-split-layout">
          
          {/* --- LEFT COLUMN: HEADING & VALUE PROPOSITION --- */}
          <div className="business-impact-left-col">
            {badge && (
              <div className="business-impact-eyebrow">
                <span className="business-impact-eyebrow-dash"></span>
                <span>{badge}</span>
                <span className="business-impact-eyebrow-dash"></span>
              </div>
            )}

            {heading && (
              <h2 className="business-impact-heading">
                {heading}
              </h2>
            )}

            {subtitle && (
              <p className="business-impact-subtitle">
                {subtitle}
              </p>
            )}

            {/* Left-Side Impact Checkpoints */}
            <div className="business-impact-check-list">
              <div className="business-impact-check-item">
                <span className="business-impact-check-dot">✓</span>
                <span>Milestone-Driven Execution Roadmaps</span>
              </div>
              <div className="business-impact-check-item">
                <span className="business-impact-check-dot">✓</span>
                <span>Elimination of Regulatory Gaps &amp; Delays</span>
              </div>
              <div className="business-impact-check-item">
                <span className="business-impact-check-dot">✓</span>
                <span>CapEx &amp; Clinical Manpower Optimization</span>
              </div>
            </div>
          </div>

          {/* --- RIGHT COLUMN: 2 BY 2 IMPACT CARDS GRID --- */}
          {impacts && impacts.length > 0 && (
            <div className="business-impact-right-col">
              <div className="business-impact-2x2-grid">
                {impacts.map((item, index) => {
                  const formattedNum = item.id || String(index + 1).padStart(2, '0');

                  return (
                    <div key={index} className="business-impact-card">
                      
                      {/* Top Glowing Accent Line */}
                      <div className="business-impact-card-hover-bar"></div>

                      {/* Header Row */}
                      <div className="business-impact-card-top">
                        <div className="business-impact-icon-box">
                          {item.icon || renderImpactIcon(item.iconType)}
                        </div>
                        <span className="business-impact-card-num">{formattedNum}</span>
                      </div>

                      {/* Title & Description */}
                      <h3 className="business-impact-card-title">
                        {item.title}
                      </h3>

                      <p className="business-impact-card-desc">
                        {item.description}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

        </div>

      </div>
    </section>
  );
};

export default BusinessImpact;